import React , { useState , useEffect } from 'react';
import webapi from '../../../api/webapi';
import Header from '../Header/Header'
import Footer from '../Footer/Footer'

const Support = (props) => {
    const [statments,setStatments] = useState(undefined)
    const [pageData,setPageData] = useState(undefined)
    const [pageHtmlData,setPageHtmlData] = useState(undefined)
    const [languageInfo,setLanguageInfo] = useState(undefined);    
        
    useEffect(()=>{
        async function getLanguageInfo(){
            var languageCode;
            var responseResultLanguageinfo
            if (new URLSearchParams(props.location.search).get("lang")!=null)
            {
                //console.log('langFromURL: ',new URLSearchParams(props.location.search).get("lang"));
                //console.log('langFromSubDomain: ',window.location.host.split(".")[0]);
                languageCode = new URLSearchParams(props.location.search).get("lang");
                responseResultLanguageinfo = await webapi.get('pages/languageInfo/'+languageCode);
                //console.log(languageInfo);
            }else{
                responseResultLanguageinfo = {data:[{Code:"fa",Title:"فارسی",Direction:"rtl"}]};
            }
            
            // console.log(responseResultLanguageinfo.data.length);
            // console.log(responseResultLanguageinfo.data);
            
            if (responseResultLanguageinfo && responseResultLanguageinfo.data && responseResultLanguageinfo.data.length>0){
                setLanguageInfo(responseResultLanguageinfo.data);
                //setState({lang : responseResultLanguageinfo.data[0].Code});
                document.getElementsByTagName('html')[0].setAttribute("lang", responseResultLanguageinfo.data[0].Code);
                document.getElementsByTagName('html')[0].setAttribute("dir", responseResultLanguageinfo.data[0].Direction);
            }
        }

        getLanguageInfo ();

        //getPage();
        //fetch('https://api.ipify.org/?format=json')
        // fetch('https://geolocation-db.com/json/')
        //     .then(response => {
        //         return response.json();
        //     }, "jsonp")
        //     .then(res => {
        //         setLog('pages/log/books_'+props.match.params.bookgroupcode+'/visit/'+res.IPv4.replaceAll('.',','))
        //     })
        //     .catch(err => setLog('pages/log/books_'+props.match.params.bookgroupcode+'/visit/'+err));
    },[])


    useEffect(()=>{
        async function getPage() {
            if (languageInfo){
                    const pageList = await webapi.get('pages/datapages/702/'+languageInfo[0].Code);
                    //console.log(pageList);
                    setPageData(pageList.data)
                }else{
                    const pageList = await webapi.get('pages/datapages/702/fa');
                    //console.log(pageList);
                    setPageData(pageList.data);
                }
                if (languageInfo)
                {
                    const pageHtml = await webapi.get('pages/htmlpages/702/'+languageInfo[0].Code);   
                    //console.log(bodyList);     
                    setPageHtmlData(pageHtml.data)
                }
            }
        getPage();
    },[languageInfo])

    // async getPage() {
    //     if (LanguageInfo)
    //     {
    //         const pageList = await webapi.get('pages/datapages/702/'+LanguageInfo[0].Code);
    //         //console.log(pageList);
    //         setState({
    //             pageData: pageList.data
    //         });
    //     }else{
    //         const pageList = await webapi.get('pages/datapages/702/fa');
    //         //console.log(pageList);
    //         setState({
    //             pageData: pageList.data
    //         });
    //     }
    
    //     const pageHtml = await webapi.get('pages/htmlpages/702/'+LanguageInfo[0].Code);   
    //     //console.log(bodyList);     
    //     setState({
    //         pageHtmlData: pageHtml.data
    //     });
    // }
    
    
        if (languageInfo && pageData && pageHtmlData) {
            return  (
                [
                    <div>
                        <Header languageInfo = {languageInfo}/>
                        <div className="container-fluid" id="innerpage_row_1">
                            <div className="container">
                                <h1 id="page_title">{pageData.length!==0 && pageData[0].F702!== undefined?pageData[0].F702:702/*راهنمای جستجو در پایگاه*/}</h1>
                            </div>
                        </div>
                        
                        <div className="container-fluid">
                            <div className="container container_70">
                                {
                                    pageHtmlData.map((HtmlParagraph,i) =>{  
                                        return(
                                            HtmlParagraph != null 
                                            ?
                                            (
                                                <div key={'a'+i}>
                                                    {/*
                                                    <section
                                                        className="data-title"
                                                        dangerouslySetInnerHTML={{ __html:HtmlParagraph.H702}}  
                                                    />*/
                                                    }
                                                    <section
                                                        className="data-body"
                                                        dangerouslySetInnerHTML={{ __html:HtmlParagraph.H702}}  
                                                    />
                                                    <br />
                                                </div>
                                            )
                                            :
                                            (
                                                null
                                            )
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div> 
                    ,
                    <Footer lang = {languageInfo[0].Code}/>
                ]
            );
        } else {
            return  null
        }
 }

 export default Support;